import * as React from 'react';
import { ca } from '@cian/analytics';
/**
 * Разметка: https://conf.cian.tech/pages/viewpage.action?pageId=1413840548
 */
export function useTracking(_ref) {
  var newbuildingId = _ref.newbuildingId,
    pageTypeJK = _ref.pageTypeJK,
    houseId = _ref.houseId;
  var page = React.useMemo(function () {
    var isSeoPage = pageTypeJK === 'Seo';
    var pageType = isSeoPage ? 'Normal' : pageTypeJK;
    var extra = {
      PageTypeJK: pageType
    };
    if (isSeoPage) {
      extra.is_seo = true;
    }
    return {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: extra
    };
  }, [pageTypeJK]);

  /**
   * Старое событие, в статье отсутствует, используется для перехода в листинги по ссылкам
   * в нижнем блоке и при переходе в КаОб из списка планировок при наличии только одного оффера
   */
  var trackListingLinkClick = React.useCallback(function (action) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_JK',
      action: action,
      label: 'layout',
      page: page,
      products: [{
        id: newbuildingId,
        offertype: 'JK',
        extra: {
          room_num: null,
          corpus_id: houseId || null
        }
      }]
    });
  }, [page, newbuildingId, houseId]);

  /**
   * Событие открытия модалки офферов (№2)
   */
  var trackOffersModalOpen = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'show_sopr',
      label: 'modal_open',
      page: page
    });
  }, [page]);

  /**
   * Событие перехода в карточку объекта из модалки офферов (№3)
   */
  var trackModalOfferLinkClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_card',
      page: page
    });
  }, [page]);

  /**
   * Событие перехода из модалки листинг внутри ЖК (№4)
   */
  var trackModalListingLinkClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_listing_jk',
      page: page
    });
  }, [page]);
  return React.useMemo(function () {
    return {
      trackListingLinkClick: trackListingLinkClick,
      trackOffersModalOpen: trackOffersModalOpen,
      trackModalOfferLinkClick: trackModalOfferLinkClick,
      trackModalListingLinkClick: trackModalListingLinkClick
    };
  }, [trackListingLinkClick, trackOffersModalOpen, trackModalOfferLinkClick, trackModalListingLinkClick]);
}